import { useLocation } from "react-router-dom";
/**
 * Read the active `draftId` from the current URL's query string.
 *
 * The draft editor flow (UnifiedSearch in `mode=draftEdit`, the EntityForm
 * pages reached from it, the deep-link Edit buttons inside the form) all
 * carry the target draft's id in the `?draftId=` query param so the
 * triple-write endpoints (`/api/v1/data-assets/draft/{draftId}/...`) know
 * which draft's named graph to mutate.
 *
 * Returns `null` when no draftId is present — callers should fall back to
 * a no-op or surface an error rather than guess.
 */
export function useDraftId() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    return params.get("draftId");
}
